<script setup lang="ts">

import { useBackButton } from "@app/Components/Utilities";
import { useViewModelInstance } from "@app/MyGarage/Types/MyGarageViewModelStore";

useBackButton();

const viewModel = await useViewModelInstance();

</script>

<template>

    <div class="bg-white dark:bg-gray-850 tracking-wider text-sm lg:text-base
                 w-full h-full overflow-y-auto flex flex-col pb-12">

        <div class="flex justify-center items-center my-6">
            <strong class="text-lg font-bold">Flat Battery?</strong>
        </div>     

        <div class="flex flex-col w-full gap-3 px-4 lg:px-6">
        
            <h1>
                Flat car battery? Don't worry we have all been there!
            </h1>

            <div class="flex flex-col w-full gap-3 dark:text-gray-300">
            
                <div v-if="viewModel.carePlan.roadsideAssistance.isEnabled">
                    <p>
                        The first and easiest step to take is to get in contact with your
                        Roadside Assist provider. If you don't have one Carbucks has partnered with
                        Roadside Assist providers that will be able to assist even if you aren't a member.
                    </p>

                    <div class="flex justify-center py-4">
                        <RoadsideAssistanceButton /> 
                    </div>
                </div>
                
                <p>
                    <span class="dark:text-white">Jump-start the battery:</span>
                    If you have jumper cables and another vehicle with a working battery 
                    nearby, you can jump-start your car. Follow these steps:
                </p>        

                <ul class="pl-3 lg:pl-5 flex flex-col w-full gap-2 dark:text-gray-300 list-decimal">
                    
                    <li>
                        Position the two vehicles close enough so that the jumper cables
                        can reach both batteries but make sure they are not touching.
                    </li>

                    <li>
                        Turn off both cars and open their hoods.
                    </li>        

                    <li>
                        Connect one end of the red (positive) jumper cable to the positive 
                        terminal on the dead battery.
                    </li>

                    <li>
                        Connect the other end of the red jumper cable to the positive 
                        terminal on the working battery.
                    </li>        

                    <li>
                        Connect one end of the black (negative) jumper cable to the 
                        negative terminal on the working battery.
                    </li>

                    <li>
                        Connect the other end of the black jumper cable to an unpainted 
                        metal surface on the engine block or chassis of the car with the 
                        dead battery (this acts as a ground).
                    </li>

                    <li>
                        Start the engine of the working car and let it run for a few minutes.
                    </li>

                    <li>
                        Try to start your car. If it starts, let it run for a while to charge the battery.
                    </li>

                </ul>

                <p>
                    <span class="dark:text-white">Replace the battery:</span>
                    If your car battery is old or not holding a charge, you may need to replace it. You can 
                    take your car to an auto parts store or a mechanic to have the battery 
                    tested and replaced if necessary.
                </p>        

            </div>

        </div>

    </div>   
    
</template>
